export default "__VITE_ASSET__BUcWduFv__"